import { Button, Space, Switch, Table } from "antd";
import { useTranslation } from "react-i18next";

import type { ColumnsType } from "antd/es/table";
import { IInventory, IProduct } from "@interfaces";
import { useNotify } from "@utils";

import { memo } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "@redux";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { PATH_PRODUCT_CREATE } from "@configs";

interface IProps {
  data: IInventory[];
  callback: () => void;
}
export const InventoryTable = memo(({ data, callback }: IProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { success, error } = useNotify();

  const dataSource: IInventory[] = data;

  const columns: ColumnsType<IInventory> = [
    {
      title: t("page.suk_code"),
      dataIndex: "",
      key: "1",
    },
    {
      title: t("page.batch_number"),
      dataIndex: "",
      key: "1",
    },
    {
      title: t("page.expiry_date"),
      dataIndex: "",
      key: "1",
    },
    {
      title: t("page.code_storage_item"),
      dataIndex: "",
      key: "1",
    },
    {
      title: t("page.stock_status"),
      dataIndex: "",
      key: "1",
    },
    {
      title: t("page.actions"),
      key: "9",
      render: (_, record) => (
        <Space size="middle">
          <Switch onChange={(value: boolean) => onChange(value, record)} />
          <Space>
            <Link to={PATH_PRODUCT_CREATE + `/${record.productId}`}>
              <Button type="ghost" icon={<EditOutlined />} size={"small"} />
              <span>{t("page.edit")}</span>
            </Link>
          </Space>
        </Space>
      ),
    },
  ];

  const onChange = async (value: boolean, record: IInventory) => {
    try {
      dispatch(setLoading(true));
      await console.log("call update api");
      callback();
      success(t("message.update.success"));
    } catch (err: any) {
      error(t("message.update.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return <Table dataSource={dataSource} rowKey={"userId"} columns={columns} pagination={false} />;
});
